import {useEffect, useState} from "react";
import Modal from 'react-modal';
import {GrClose, GrGift, GrDown} from  'react-icons/gr';
import Slider from "react-slick";
import fetch from 'isomorphic-fetch';
import classNames from "classnames";
import ComplementDetail from "./complement_detail";
import {useRouter} from "next/router";

const Complement = ({Type}) =>{
    const router = useRouter();
    const [data, setData] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [active, setActive] = useState(null);
    const [isShowItemID, setIsShowItemID] = useState(null);

    useEffect(()=>{
        fetch('/api/complement')
            .then(function(response) {
                return response.json();
            })
            .then(function(d) {
                setData(d);
            });
    },[]);

    const openModal =()=>{
        setIsOpen(true);
        setActive(null);
        setIsShowItemID(null);
    }

    function closeModal() {
        setIsOpen(false);
        if(Type === 'cart'){
            router.push('/compra');
        }
    }

    const settings = {
        infinite: true,
        speed: 500,
        lazyLoad:true,
        slidesToShow: 3,
        slidesToScroll: 3,
        pauseOnHover: true,
        autoplay: true,
        dots:false,
        responsive:[{
            breakpoint: 640,
            settings: {
                slidesToShow: 2
            }
        }]
    };

    const slider = ()=>{
        return data.map((i, k)=>{
            if(i.products?.length) {
                const tmp = i.products[0];
                return <div key={k}>
                    <div className="dycComplementCarouselItem" onClick={()=>{ setIsOpen(true); setIsShowItemID(tmp.id_producto); }}>
                        <div className="dycComplementCarouselItemImage" style={{backgroundImage: `url(${tmp.fotos[0].url})` }}>
                        </div>
                        <p >{tmp.nombre}</p>
                        <span>${tmp.precio} MXN</span>
                    </div>
                </div>
            }
        })
    };

    const handleActive = (k)=>{
        const f = (k === active) ? null : k;
        setActive(f)
    }

    const modalContent = ()=>{
        if(isShowItemID){
            let final = null;
            data.map(i=>{
                i.products.filter( g=>{
                    if(g.id_producto === isShowItemID){
                        final = g;
                    }
                })
            });
            if(final?.id_producto){
                return <ComplementDetail data={final} setIsShowItemID={setIsShowItemID}/>
            }else{
                setIsShowItemID(null);
            }
        }else{
            return data.map((i,k)=>{
                return <div className={classNames('dycComplementModalItem', {'active': (k===active)})} key={k}>
                    <div className="dycComplementModalTitle" onClick={()=>{handleActive(k)}}>
                        <div>
                            <img src={i.icon} alt={i.name}/>
                        </div>
                        <h3>{i.name}</h3>
                        <GrDown/>
                    </div>
                    <ul className="dycComplementModalContent">
                        { i.products.map(d=>{
                            return <li key={d.id_producto} onClick={()=>{ setIsShowItemID(d.id_producto) }}>
                                <div className="dycComplementModalContentImg" style={{backgroundImage: `url(${d.fotos[0].url})`}}/>
                                <p>{d.nombre}</p>
                                <span>${d.precio}MXN</span>
                            </li>
                        }) }
                    </ul>
                </div>
            })
        }
    };

    return <div className={classNames('dycComplement', {'marginBottom-big' : Type != 'cart'})}>
        { (data.length) ? (<>
            <div className="dycComplementOptions">
                <section className="dycComplementCarousel">
                    <Slider {...settings}>
                        {slider()}
                    </Slider>
                </section>
                <section className="dycComplementCta" onClick={openModal}>
                    <div>
                        <div>
                            <GrGift/>
                            <span>Ver más regalos</span>
                        </div>
                    </div>
                </section>
            </div>

            <Modal
                isOpen={modalIsOpen}
                className="dycModal"
                overlayClassName="dycModalOverlay"
                ariaHideApp={false}
            >
                <div className="dycModalHeader">
                    <h1 className="dycModalTitle">Complementa tu compra</h1>
                    <span className="dycModalClose" onClick={closeModal}>
                        <GrClose/>
                    </span>
                </div>
                <div className="dycModalBody">
                    <section className="dycComplementModal">
                        {modalContent()}
                    </section>
                </div>
            </Modal>
        </>) : (
            <div className="flex-center">
                <div className="progressTxt">Espera un momento...</div>
                <div className="progress"><span className="progress-bar"/></div>
            </div>
        ) }
    </div>
};

export default Complement;
